import "core-js/modules/es.object.define-property";

var _formatTypes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
// export const ACCOUNT_NUMBER = 'ACCOUNT_NUMBER'
export var DOLLAR_DECIMAL = 'DOLLAR_DECIMAL';
export var DOLLAR_SIGN_WHOLE = 'DOLLAR_SIGN_WHOLE';
export var DOLLAR_SIGN_DECIMAL = 'DOLLAR_SIGN_DECIMAL';
export var DOLLAR_WHOLE = 'DOLLAR_WHOLE'; // export const DOLLAR_WHOLE_DECIMAL = 'DOLLAR_WHOLE_DECIMAL'

export var PERCENTAGE = 'PERCENTAGE';
export var PERCENTAGE_DECIMAL = 'PERCENTAGE_DECIMAL'; // export const SSN = 'SSN'

export var SSN_LAST_4_DIGIT = 'SSN_LAST_4_DIGIT';
var formatTypes = (_formatTypes = {}, _defineProperty(_formatTypes, DOLLAR_DECIMAL, '^[0-9.]*$'), _defineProperty(_formatTypes, DOLLAR_WHOLE, '^[0-9,]*$'), _defineProperty(_formatTypes, DOLLAR_SIGN_WHOLE, '^[0-9,$]*$'), _defineProperty(_formatTypes, DOLLAR_SIGN_DECIMAL, '^[0-9.]*$'), _defineProperty(_formatTypes, PERCENTAGE, '^[0-9]$'), _defineProperty(_formatTypes, PERCENTAGE_DECIMAL, '^[0-9.]*$'), _defineProperty(_formatTypes, SSN_LAST_4_DIGIT, '^\\d{4}$'), _formatTypes);
export default formatTypes;